import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { loginActions } from './action/loginAction';
import { withTranslation } from 'react-i18next';
import { appVariables } from './helpers/appVariables';
import { alertActions } from './action/AlertAction';
import Header from './Header/Header';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { commonClass } from './helpers/commonClass';
import CTurnstile from '../component/Cookie/CTurnstile'
import { history } from './helpers/history';
import BonusDetailspopup from './bonuspopup';
import { gameActions } from './action/GameAction';
import Footer from './Footer/Footer';
class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            regMobileNo: '', TandC: false, firstName: '', lastName: '', password: '', Countrydetails: [], Selcountry: {}, showpwd: false, age: false, Countryfilter: '', Default: {}, setToken: "", UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {}, regUserid: "",
            PlayerrefferalCode: sessionStorage.getItem('plyrid') ? sessionStorage.getItem('plyrid') : '',
            bonuspopup: false, SelectBonusObj: {}, filtertype: 1, Bonusflag: false,
            // ErrorFlag
            ErrorFirstname: "", ErrorLastname: "", Errorpassword: "", ErrorRegisterNo: "", ErrorregUserid: "",
            FstVal: "Mr"
        }
        this.btnGetOTP = this.btnGetOTP.bind(this);
        this.props.logout(this.props.user.mobileNo, 1);
        this.childRef = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => { window.HomePageOfferimg() }, 1000)//700
        this.GetCountryList();
        setTimeout(() => {
            this.GetUserCountry();
        }, 300);
        if (!this.props.Availbonus || this.props.Availbonus.length <= 0) {
            this.props.ShowAvailableBonus(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.state.filtertype);
        }
    }
    toggleCountry = () => { window.setCountryToggle(); }
    countryChange = (data) => {
        this.setState({ Selcountry: data, regMobileNo: '' });
        this.toggleCountry();
        this.state.Countryfilter = ''
    }
    toggleVal = () => {
        window.setCountryToggleReg();
    };
    handleTextChange(e) {
        try {
            this.SetEmpty()
            let value = e.target.value
            if ([e.target.name] == "regMobileNo" || [e.target.name] == 'PlayerrefferalCode') {
                const regex = /^[0-9\b]+$/;
                if (!regex.test(value) && !value == '') { return; }
            }
            else if ([e.target.name] == "firstName" || [e.target.name] == "lastName") {
                const regex = /^[a-zA-Z ]*$/;
                if (!regex.test(value) && !value == '') { return; }
                // value = value.replace(/[^A-Za-z]/ig, '')
            }
            else if ([e.target.name] == "regUserid") {
                if (this.props.suggestuserid && this.props.suggestuserid.length > 0) {
                    this.props.ClearSuggestUserId()
                }
                const regex = /^[a-zA-Z0-9]*$/;
                if (!regex.test(value) && !value == '') { return; }
                // value = value.replace(/[^A-Za-z]/ig, '')
            }
            this.setState({ [e.target.name]: value });
        } catch (ex) { }
    }
    // btnGetOTP(e) {
    //     if (e) {
    //         e.preventDefault();
    //     }
    //     if (this.state.firstName && this.state.firstName.trim() != "" && this.state.firstName.length > 2) {
    //         this.setErrorMessage(1, "")
    //         if (this.state.lastName && this.state.lastName.trim() != "") {
    //             this.setErrorMessage(2, "")
    //             if (this.state.regUserid && this.state.regUserid.trim() != "") {
    //                 this.setErrorMessage(3, "")
    //                 if (this.props.suggestuserid == "0") {
    //                     this.setErrorMessage(3, "")
    //                     if (this.state.regMobileNo && this.state.regMobileNo.trim() != "" && this.state.regMobileNo.length <= this.state.Selcountry.mobNolength && this.state.regMobileNo.length >= this.state.Selcountry.mobNoMinlength) {
    //                         this.setErrorMessage(4, "")
    //                         if (this.state.password && this.state.password.trim() != "") {
    //                             this.setErrorMessage(5, "")
    //                             // let regEx = /^(?=.*?[0-9])(?=.*?[^0-9A-Za-z]).{8,20}$/;
    //                             let regEx = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,20}$/
    //                             if (regEx.test(this.state.password)) {
    //                                 this.setErrorMessage(5, "")
    //                                 if (this.state.TandC !== false) {
    //                                     if (this.state.Availbonus && this.state.Availbonus.length > 0 && Object.keys(this.state.SelectBonusObj).length <= 0 && this.state.Bonusflag == false) {
    //                                         this.setState({ Bonusflag: true })
    //                                         return
    //                                     }
    //                                     if (this.state.age !== false) {
    //                                         this.state.password = this.state.password.replace(/'/g, "''");
    //                                         this.state.firstName = this.state.firstName[0].toUpperCase() + this.state.firstName.slice(1);
    //                                         this.state.lastName = this.state.lastName[0].toUpperCase() + this.state.lastName.slice(1);
    //                                         // this.props.Otpgen(this.state.regMobileNo, appVariables.OTP.Register, this.props.i18n.language, this.props.user.loginKey, this.state.firstName, this.state.lastName, this.state.password, this.state.Selcountry.flag);
    //                                         let bonusid = Object.keys(this.state.SelectBonusObj).length > 0 ? this.state.SelectBonusObj.bonus_id : "0";
    //                                         this.props.Otpgen2(this.state.regMobileNo, appVariables.OTP.Register, this.props.i18n.language, this.props.user.loginKey, this.state.firstName, this.state.lastName, this.state.password, this.state.Selcountry.flag, this.state.setToken, this.state.regUserid, this.state.PlayerrefferalCode, bonusid);
    //                                         this.handleClick();
    //                                     }
    //                                     else { this.showMsg('lblPlsIndicateAge'); }
    //                                 }
    //                                 else { this.showMsg('lblAcceptTermCond'); }
    //                             }
    //                             else { this.showMsg('lblReqPasswordPolicy', 5); }
    //                         }
    //                         else { this.showMsg('lblEnterPwd', 5); }
    //                     }
    //                     else { this.showMsg('lblValidMobileNo', 4); }
    //                 }
    //                 else { this.showMsg('lblverfyuserid', 3); }
    //             }
    //             else { this.showMsg('lblEnteruserid', 3); }
    //         }
    //         else { this.showMsg('lblEnterLastname', 2); }
    //     }
    //     else { this.showMsg('lblFnamelength', 1); }
    // }

    btnGetOTP = (e) => {
        if (e) {
            e.preventDefault();
        }
        const { firstName, lastName, regUserid, regMobileNo, password, TandC, Availbonus, SelectBonusObj, Bonusflag, age, Selcountry, setToken, PlayerrefferalCode, FstVal } = this.state;
        const { suggestuserid, i18n, user } = this.props;
        let validationfalg = true
        // First name validation
        if (!firstName || firstName.trim() === "" || firstName.length <= 2) {
            this.showMsg('lblEnterFirstname', 1);
            validationfalg = false;
        }
        // Last name validation
        if (!lastName || lastName.trim() === "") {
            this.showMsg('lblEnterLastname', 2);
            validationfalg = false;
        }
        // User ID validation
        if (!regUserid || regUserid.trim() === "") {
            this.showMsg('lblEnteruserid', 3);
            validationfalg = false;
        }
        if (suggestuserid !== "0") {
            this.showMsg('lblverfyuserid', 3);
            validationfalg = false;
        }
        // Mobile number validation
        if (!regMobileNo || regMobileNo.trim() === "" || regMobileNo.length < Selcountry.mobNoMinlength || regMobileNo.length > Selcountry.mobNolength) {
            this.showMsg('lblValidMobileNo', 4);
            validationfalg = false;
        }
        // Password validation
        if (!password || password.trim() === "") {
            this.showMsg('lblEnterPwd', 5);
            validationfalg = false;
        }
        const regEx = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,20}$/;
        if (!regEx.test(password)) {
            this.showMsg('lblReqPasswordPolicy', 5);
            validationfalg = false;
        }
        // Terms and Conditions
        if (TandC === false) {
            this.showMsg('lblAcceptTermCond');
            validationfalg = false;
        }
        // Age confirmation
        if (age === false) {
            this.showMsg('lblPlsIndicateAge');
            validationfalg = false;
        }

        // Bonus selection
        // if (Availbonus && Availbonus.length > 0 && Object.keys(SelectBonusObj).length <= 0 && Bonusflag === false && validationfalg) {
        //     this.setState({ Bonusflag: true });
        //     validationfalg = false;
        // }
        // All validations passed - format and submit
        if (validationfalg) {
            const sanitizedPassword = password.replace(/'/g, "''");
            const capitalizedFirstName = firstName[0].toUpperCase() + firstName.slice(1);
            const capitalizedLastName = lastName[0].toUpperCase() + lastName.slice(1);
            const bonusid = Object.keys(SelectBonusObj).length > 0 ? SelectBonusObj.bonus_id : "0";
            this.props.Otpgen2(regMobileNo, appVariables.OTP.Register, i18n.language, user.loginKey, capitalizedFirstName, capitalizedLastName, sanitizedPassword, Selcountry.flag, setToken, regUserid, PlayerrefferalCode, bonusid, FstVal);
            this.handleClick();
        }
    };

    SetEmpty = () => {
        this.setState({ ErrorFirstname: "" })
        this.setState({ ErrorLastname: "" })
        this.setState({ ErrorregUserid: "" })
        this.setState({ ErrorRegisterNo: "" })
        this.setState({ Errorpassword: "" })
    }


    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ErrorFirstname: errorstring })
                break;
            case 2:
                this.setState({ ErrorLastname: errorstring })
                break;
            case 3:
                this.setState({ ErrorregUserid: errorstring })
                break;
            case 4:
                this.setState({ ErrorRegisterNo: errorstring })
                break;
            case 5:
                this.setState({ Errorpassword: errorstring })
                break;
            default:
                break;
        }
    }
    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }
    HandleCheckBox = (e) => {
        let Ischecked = e.target.checked;
        let name = e.target.name;
        this.setState({ [name]: Ischecked })
    }

    handleChange = (e) => {
        this.SetEmpty()
        e.preventDefault()
        let name = e.target.name;
        this.setState({ [name]: e.target.value })
        this.state.Countryfilter = e.target.value;
    }

    GetCountryList = () => {
        let new_Version = 0;
        let Version_old = localStorage.getItem('countryver');
        if (this.props.appvariables.bVersion) {
            let totalversion = this.props.appvariables.bVersion.split("~")
            if (totalversion.length > 0) {
                new_Version = totalversion[3];
            }
        }
        if (Version_old != new_Version) {
            commonClass.GetCountry(new_Version)
                .then(response =>
                    response.json()
                )
                .then(data => {
                    if (data) {
                        localStorage.setItem('countryver', new_Version);
                        localStorage.setItem('countrylst', JSON.stringify(data));
                        this.setState({ Countrydetails: data })
                        // this.setState({ Selcountry: data.default })
                        this.setState({ Default: data.default })
                    }

                });
        }
        else {
            let CountryList = JSON.parse(localStorage.getItem('countrylst')); // get from localstorage for countrylist
            this.setState({ Countrydetails: CountryList })
            // this.setState({ Selcountry: CountryList.default })
            this.setState({ Default: CountryList.default })
        }
    }

    GetUserCountry = () => {
        let mythis = this;
        try {
            commonClass.GetUserCountry()
                .then(response =>
                    response.json()
                )
                .then(data => {
                    if (data) {
                        let LoadCountry = this.state.Countrydetails.other.filter(Fobj => Fobj.isocode2 == data.country)
                        if (LoadCountry && LoadCountry.length > 0) {
                            this.setState({ Selcountry: LoadCountry[0] })
                            try {
                                let GetAlllang = commonClass.AllLanguage();
                                let GetLangCountry = GetAlllang.filter(Fobj => Fobj.countrycode == LoadCountry[0].flag);
                                if (localStorage.getItem('ipcountry')) {
                                    if (GetLangCountry && GetLangCountry.length > 0 && JSON.parse(localStorage.getItem('ipcountry'))) {
                                        if (GetLangCountry.length > 1) {
                                            GetLangCountry = GetLangCountry.sort((a, b) => a.sort - b.sort);
                                        }
                                        const { i18n } = this.props;
                                        localStorage.removeItem('ipcountry')
                                        localStorage.setItem('language', JSON.stringify(GetLangCountry[0].lang));
                                        document.cookie = "gtlang=" + GetLangCountry[0].lang;
                                        i18n.changeLanguage(GetLangCountry[0].lang);
                                    }
                                }
                            } catch (error) {

                            }
                        }
                        else {
                            this.setState({ Selcountry: this.state.Default })
                        }
                    }
                    else {
                        this.setState({ Selcountry: this.state.Default })
                    }
                }).catch(function (err) {
                    mythis.setState({ Selcountry: mythis.state.Default })
                });
        } catch (error) {
            mythis.setState({ Selcountry: mythis.state.Default })
        }
    }

    handleTurnstileChange = async (value) => {
        this.setState({ setToken: value });
    }

    handleClick = () => {
        if (this.childRef.current) {
            this.childRef.current.resetToken();
        }
    };

    CloseImage = () => {
        this.setState({ bonuspopup: !this.state.bonuspopup })
    }

    bonusdetailscontrol = () => {
        this.setState({ bonuspopup: !this.state.bonuspopup })
        setTimeout(() => { window.HomePageOfferimg() }, 1000)//700
    }

    GetSelectBonus = (Obj) => {
        this.setState({ SelectBonusObj: Obj })
    }

    static getDerivedStateFromProps(props, state) {
        return { Availbonus: props.Availbonus };
    };

    userConfirmation = (flag, option) => {
        this.setState({ Bonusflag: flag });
        if (option == 0) {
            this.btnGetOTP()
        }
    }

    verify = () => {
        if (this.state.regUserid.length <= 0) {
            this.showMsg(this.props.t('lblvalregmsg'));
            return
        }
        else if (this.state.regUserid.length < 3) {
            this.showMsg(this.props.t('lblminlength'));
            return
        }
        else if (this.props.suggestuserid != "0") {
            this.setErrorMessage(3, "")
            this.props.IsAvailableUserID(this.state.regUserid, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey)
            return
        }
        else if (this.props.suggestuserid == "0") {
            this.showMsg(this.props.t('lblusernameverified'))
            return
        }
    }
    fstNameVal = (val) => {
        this.setState({ FstVal: val })
        window.setCountryToggleReg()
    }
    render() {
        const { t } = this.props;
        let IsErrorregUserid = this.state.ErrorregUserid.length > 0;
        let IsFirstname = this.state.ErrorFirstname.length > 0;
        let IsErrorLastname = this.state.ErrorLastname.length > 0;
        let IsErrorRegisterNo = this.state.ErrorRegisterNo.length > 0;
        let IsErrorpassword = this.state.Errorpassword.length > 0;

        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                        <title>Create Lottery Account | Join 3D 5D 6D Games and Win Today | Gulf Ticket</title>
                        : <title>Start Playing Now | Create Your Free Gaming Account | Gulf Ticket</title>
                    }
                    {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                        <meta name="description" content="Sign up to access 3D, 5D, and 6D games online. Join Gulf Ticket to play, check results, and start winning today with your own account." />
                        : <meta name="description" content="Register your Gulf Ticket account online and start playing 3D, 5D, and 6D lotteries today. Simple sign-up, quick draws, and daily prize chances." />
                    }

                    <meta name="keywords" content="Gulf Ticket, online raffle draw, Biggest Online Draw" />

                    <meta property="og:title" content="Gulf Ticket - Register" />
                    <meta property="og:site_name" content="Gulf Ticket" />
                    <meta property="og:url" content="https://gulfticket.com" />
                    {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                        <meta name="description" content="Sign up to access 3D, 5D, and 6D games online. Join Gulf Ticket to play, check results, and start winning today with your own account." />
                        : <meta name="description" content="Register your Gulf Ticket account online and start playing 3D, 5D, and 6D lotteries today. Simple sign-up, quick draws, and daily prize chances." />
                    }

                    <meta property="og:type" content="website" />
                    <meta property="og:image" content="https://gulfticket.com/assets/img/logo.png" />
                </Helmet>}
                <Header />
                <div class="subContainer">
                    <div class="register">
                        <div class="registerInr">
                            <h1>  {t('lblregmsg')}</h1>
                            <span class="subTitle">{t('lblregmsginfo')}</span>
                            <form class="register-form margin-top-20" onSubmit={this.btnGetOTP}>
                                <div class="formCont">
                                    <label> {t('lbluserid')}<sup>*</sup></label>
                                    <input disabled={this.props.suggestuserid == "0"} type="text" className={`${IsErrorregUserid ? "errorBorder" : ""}`} placeholder="Enter User Id*" name='regUserid' value={this.state.regUserid} onChange={this.handleTextChange.bind(this)} maxLength={15} autocomplete="off" />
                                    {IsErrorregUserid && <div class="errorTxt">{this.state.ErrorregUserid}</div>}
                                    {this.props.suggestuserid && this.props.suggestuserid.length > 0 && this.props.suggestuserid != "0" && <div class="errorTxt">This name already exists. Choose another or pick from suggestions below.</div>}
                                    <a onClick={() => { this.verify() }} class={`verifyBtn ${this.props.suggestuserid == "0" ? 'activeTxt' : 'opacityRemove'}`}>{this.props.suggestuserid == "0" && <small><img src="./assets/img/icons/green-tick-line.png" /></small>}{t('lblVerify')}</a>
                                </div>

                                {this.props.suggestuserid && this.props.suggestuserid.length > 0 && this.props.suggestuserid != "0" &&
                                    <div class="formCont formContError1">
                                        <ul>
                                            {this.props.suggestuserid.split(',').length > 0 && this.props.suggestuserid.split(',').map((item, inx1) =>
                                                <li>{item}</li>
                                            )}
                                        </ul>
                                    </div>}

                                <div class="formCont">
                                    <label>{t('lblFirstName')} <sup>*</sup></label>
                                    <div class="countryCodes">
                                        <a class="countryImg" onClick={() => this.toggleVal()}><small class="regLble">{this.state.FstVal}</small></a>
                                        <ul class="selContry scrollbar" id="NewselContry">
                                            <li onClick={() => this.fstNameVal("Mr")}><a>Mr.</a></li>
                                            <li onClick={() => this.fstNameVal("Ms")}><a>Ms.</a></li>
                                            <li onClick={() => this.fstNameVal("Mrs")}><a>Mrs.</a></li>
                                        </ul>
                                    </div>
                                    {/* <input type="text" className={`${IsFirstname ? "errorBorder" : ""}`} placeholder={`${t('lblFirstName')}*`} name='firstName' value={this.state.firstName} onChange={this.handleTextChange.bind(this)} maxLength={30} autocomplete="off" /> */}
                                    <input type="text" class="inputMobile" placeholder={`${t('lblFirstName')}*`} name='firstName' value={this.state.firstName} onChange={this.handleTextChange.bind(this)} maxLength={30} autocomplete="off" />
                                    {IsFirstname && <div class="errorTxt">{this.state.ErrorFirstname}</div>}
                                </div>

                                <div class="formCont">
                                    <label>{t('lblLastName')} <sup>*</sup></label>
                                    <input type="text" className={`${IsErrorLastname ? "errorBorder" : ""}`} placeholder={`${t('lblLastName')}*`} name='lastName' value={this.state.lastName} onChange={this.handleTextChange.bind(this)} maxLength={30} autocomplete="off" />
                                    {IsErrorLastname && <div class="errorTxt">{this.state.ErrorLastname}</div>}
                                </div>

                                <div class="formCont">
                                    <label>{t('lblrefcode')}</label>
                                    <input type="tel" placeholder={`${t('lblrefcode')}`} name='PlayerrefferalCode' value={this.state.PlayerrefferalCode} onChange={this.handleTextChange.bind(this)} maxLength={15} autocomplete="off" />
                                </div>

                                <div class="formCont">
                                    <label>{t('lblMobileNo')} <sup>*</sup></label>
                                    <div className={`countryCodes ${IsErrorRegisterNo ? "errorBorder bor-right-none" : ""}`}>
                                        <a className="countryImg" onClick={() => this.toggleCountry()}>
                                            <img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${this.state.Selcountry.flag}.png?v0`} alt={this.state.Selcountry.Ccname} />
                                            <small>{this.state.Selcountry.code}</small>
                                        </a>
                                        <ul className="selContry scrollbar" style={{ display: "none" }} id="selContry">
                                            <li><input style={{ padding: "5px 10px", margin: "5px", height: "35px" }} type="text" value={this.state.Countryfilter} name="Countryfilter" placeholder="Search" onChange={(e) => { this.handleChange(e) }} /></li>
                                            {this.state.Countrydetails && this.state.Countrydetails.other && this.state.Countrydetails.other.filter(country =>
                                                (country.Countryname.includes(this.state.Countryfilter.toUpperCase()) || country.flag.includes(this.state.Countryfilter))).map((data, inx) =>
                                                    <li key={`n_${inx}`}><a onClick={() => this.countryChange(data)}><img src={`${process.env.REACT_APP_CDN_URL}/assets/flags/${data.flag}.png?v0`} alt='Show Flag Icon' />{data.code}</a></li>
                                                )}
                                        </ul>
                                    </div>
                                    {this.state.Selcountry && <input type="tel" className={`inputMobile ${IsErrorRegisterNo ? "errorBorder" : ""}`} name='regMobileNo' placeholder={`${t('lblMobileNo')}*`} value={this.state.regMobileNo} onChange={this.handleTextChange.bind(this)} maxLength={this.state.Selcountry.mobNolength} autocomplete="off" />}
                                    {IsErrorRegisterNo && <div class="errorTxt">{this.state.ErrorRegisterNo}</div>}
                                </div>

                                <div class="formCont">
                                    <label>{t('lblPwd')} <sup>*</sup></label>
                                    <input className={`${IsErrorpassword ? "errorBorder" : "font-size"}`} type={this.state.showpwd ? "text" : "password"} placeholder={`${t('lblPwd')}*`} name='password' value={this.state.password} onChange={this.handleTextChange.bind(this)} maxLength={20} autocomplete="off" required />
                                    {IsErrorpassword && <div class="errorTxt">{this.state.Errorpassword}</div>}
                                    {this.state.showpwd ? <small id="eyeIcon" class="eyeIcon eyeOpen eyeClose" onClick={() => this.setState({ showpwd: false })}></small>
                                        : <small id="eyeIcon" class="eyeIcon eyeOpen eyeClose" onClick={() => this.setState({ showpwd: true })} ></small>}
                                </div>

                                <div class="formContError1">
                                    <div class="passInfo">{t('lblpassrule')}</div>
                                    <ul>
                                        <li>{t('lblpassruleone')}</li>
                                        <li>{t('lblpassruletwo')}</li>
                                        <li>{t('lblpassrulethree')}</li>
                                        <li>{t('lblpassrulefour')}</li>
                                    </ul>
                                </div>
                                <div class="formCont">
                                    <div class="checkBox">
                                        <label className="checkLble">{`${t('lbl18YearsAgeorOld')}*`}
                                            <input className="checkboxInput" type="checkbox" value={this.state.age} name='age' checked={this.state.age} onChange={(e) => { this.HandleCheckBox(e) }}></input>
                                            <span className="checkmark border-color"></span>
                                        </label>
                                    </div>
                                </div>

                                <div class="formCont">
                                    <div class="checkBox">
                                        <label className="checkLble">{t('lblAgree')}<a className="terms"><a href={`${commonClass.setUrl()}/termscondition`} target="_blank" rel="noopener" >{t('lblTermsandCondition')}</a>&nbsp;</a>{t('lblWebsite')}
                                            <input className="checkboxInput" type="checkbox" value={this.state.TandC} name='TandC' checked={this.state.TandC} onChange={(e) => { this.HandleCheckBox(e) }}></input>
                                            <span className="checkmark border-color"></span>
                                        </label>
                                    </div>
                                </div>
                                {/* <label className="checkLble" onClick={() => { this.bonusdetailscontrol() }}><b className='walletubalde'>{t('lblviewavailbonus')}</b></label>
                                {Object.keys(this.state.SelectBonusObj).length > 0 && <label>{t('lblappliedbonus')} : {this.state.SelectBonusObj.bonus_name}</label>} */}
                                <div class="formCont">
                                    <CTurnstile ref={this.childRef} gettoken={(value) => { this.handleTurnstileChange(value) }} />
                                </div>
                                <div class="formCont">
                                    <button type="submit" >{t('lblNext')}</button>
                                </div>
                            </form>
                            <span class="agree">{t('lblAlreadyAcc')} <a onClick={() => { history.push('/login') }}>{t('lblLogin')}</a></span>
                            {this.state.bonuspopup && <>
                                <div className="lightboxinfo3">
                                    <a className="lightBoxCloseReg" onClick={() => { this.CloseImage() }}><img src="./assets/img/icons/cloes-icon.png?v0.1" /></a>
                                    <div className="lightBox-wrap">
                                        <div class="mainContainer" >
                                            <div className='wrap2' style={{ backgroundColor: "white" }}>
                                                <BonusDetailspopup filtertype={this.state.filtertype} getbonus={(value) => { this.GetSelectBonus(value) }} ClosePopup={() => { this.CloseImage() }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div onClick={() => { this.CloseImage() }} className="overlay"></div>
                            </>}
                            {this.state.Bonusflag && <div>
                                <div style={{ transform: "translate(-50%, -50%)", display: "block" }} className="lightbox AlertpopUp">
                                    <div className="lightBox-wrap">
                                        <div className="userContent">
                                            <h2 style={{ padding: "10px" }}>{t('lblwithoutbonus')}</h2>
                                            <div className="altBtns">
                                                <button className="bg6" onClick={() => { this.userConfirmation(false, 0) }}>{t('lblYes')}</button>
                                                <button className="bg3" onClick={() => { this.userConfirmation(false, 1) }}>{t('lblNo')}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="overlaybetsilp" style={{ display: "block" }}></div>
                            </div>}
                        </div>
                    </div >
                </div >
                <Footer />
            </>

        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables, suggestuserid } = state.loginReducer;
    const { Availbonus } = state.gameReducer;
    return { user, appvariables, Availbonus, suggestuserid };
}
const mapActionToProps = {
    login: loginActions.login,
    Otpgen: loginActions.Register,
    // Otpgen2: loginActions.Registercloud,
    Otpgen2: loginActions.RegisterRefferal,
    alertError: alertActions.error,
    logout: loginActions.logout,
    ShowAvailableBonus: gameActions.ShowAvailableBonus,
    IsAvailableUserID: loginActions.IsAvailableUserID,
    ClearSuggestUserId: loginActions.ClearSuggestUserId
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Register))